import React, {Component} from 'react';
import './Atelier.css';
import {withTranslation} from "react-i18next";

class Atelier extends Component {
    render() {
        const {t} = this.props;
        return (
            <div className='atelier'>
                <div className='atelier-background'></div>
                <div className='atelier-text '>
                    <h5>{t('atelier.title')}</h5>
                    <h6 className='center'>{t('atelier.caption')}</h6>
                    <ul>
                        {t('atelier.part1') !== "" ? <li>{t('atelier.part1')}</li> : "" }
                        {t('atelier.part2') !== "" ? <li>{t('atelier.part2')}</li> : "" }
                        {t('atelier.part3') !== "" ? <li>{t('atelier.part3')}</li> : "" }
                        {t('atelier.part4') !== "" ? <li>{t('atelier.part4')}</li> : "" }
                        {t('atelier.part5') !== "" ? <li>{t('atelier.part5')}</li> : "" }
                        {t('atelier.part6') !== "" ? <li>{t('atelier.part6')}</li> : "" }
                    </ul>
                    {/*<h5>АВТОРСКОЕ АТЕЛЬЕ <span>ЭЛЕОНОРЫ АМОСОВОЙ</span></h5>
                    <h6 className='center'>Наши услуги:</h6>
                    <ul>
                        <li>Пошив одежды из коллекций бренда по Вашим меркам.</li>
                        <li>Создание эксклюзивных изделий с учетом Ваших пожеланий.</li>
                        <li>Разработка Вашего уникального стиля и имиджа</li>
                        <li>Помощь в создании образа и наряда для любого события.</li>
                        <li>Личные консультации с дизайнером Элеонорой Амосовой.</li>
                        <li>Помощь в создании образов и нарядов для фото и видео съемок.</li>
                    </ul>*/}
                </div>
            </div>
        )
    }
}

export default withTranslation()(Atelier);


// WEBPACK FOOTER //
// ./src/components/Atelier.jsx